import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';
import { LinkSize } from './types';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';
import { LinkColor } from './types';
import { fallbackTheme } from '../theming/fallbackTheme';
import { IconSize } from '../Icon/GenericIcon';

export const mapLinkSizeToIconSize: Record<LinkSize, IconSize> = {
  xsmall: 'xsmall',
  small: 'xsmall',
  default: 'small',
  large: 'default',
};

export const sizes: {
  [key in LinkSize]: {
    [key in 'fontSize' | 'lineHeight' | 'height' | 'width']: string;
  };
} = {
  xsmall: {
    fontSize: tokens.typography.shortText.xsmall.fontSize,
    lineHeight: tokens.typography.shortText.xsmall.lineHeight,
    width: tokens.size.space.small,
    height: tokens.size.space.small,
  },
  small: {
    fontSize: tokens.typography.shortText.small.fontSize,
    lineHeight: tokens.typography.shortText.small.lineHeight,
    width: tokens.size.space.small,
    height: tokens.size.space.small,
  },
  default: {
    fontSize: tokens.typography.shortText.default.fontSize,
    lineHeight: tokens.typography.shortText.default.lineHeight,
    width: '1.25rem',
    height: '1.25rem',
  },
  large: {
    fontSize: tokens.typography.shortText.large.fontSize,
    lineHeight: tokens.typography.shortText.large.lineHeight,
    width: '1.5rem',
    height: '1.5rem',
  },
};

export const mappedColors = (theme: BabbelTheme, color: LinkColor) => {
  const themeColor = fallbackTheme(theme).color;
  switch (color) {
    case 'default':
      return themeColor.accent.enabled;
    case 'inverse':
      return themeColor.neutral.onSurfaceInverse;
    case 'subdued':
      return themeColor.neutral.onSurfaceSubdued1;
    // deprecated, use 'emphasized' instead
    case 'highlight':
      return themeColor.brand.enabled;
    case 'emphasized':
      return themeColor.brand.enabled;
  }
};
